/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as HomeRouteImport } from './routes/home'
import { Route as ExperienceListRouteImport } from './routes/experienceList'
import { Route as EmergencyStatusRouteImport } from './routes/emergency-status'
import { Route as EmergencyModeRouteImport } from './routes/emergency-mode'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as UserProfileRouteRouteImport } from './routes/user-profile/route'
import { Route as ApplicationRouteRouteImport } from './routes/application/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WeekplanIndexRouteImport } from './routes/weekplan/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as UserProfileIndexRouteImport } from './routes/user-profile/index'
import { Route as TurnReportsIndexRouteImport } from './routes/turn-reports/index'
import { Route as TrolleyRoutesIndexRouteImport } from './routes/trolley-routes/index'
import { Route as NewsEntriesIndexRouteImport } from './routes/news-entries/index'
import { Route as ExperiencesIndexRouteImport } from './routes/experiences/index'
import { Route as DocumentsIndexRouteImport } from './routes/documents/index'
import { Route as DepotsIndexRouteImport } from './routes/depots/index'
import { Route as CongregationsIndexRouteImport } from './routes/congregations/index'
import { Route as CircuitsIndexRouteImport } from './routes/circuits/index'
import { Route as AvailabilityIndexRouteImport } from './routes/availability/index'
import { Route as ApplicationIndexRouteImport } from './routes/application/index'
import { Route as UsersCreateRouteImport } from './routes/users/create'
import { Route as UserProfileSettingsRouteImport } from './routes/user-profile/settings'
import { Route as UserProfileRoutePreferencesRouteImport } from './routes/user-profile/route-preferences'
import { Route as UserProfileCalendarSubscriptionRouteImport } from './routes/user-profile/calendar-subscription'
import { Route as UserProfileAccountRouteImport } from './routes/user-profile/account'
import { Route as TurnReportsTurnReportIdRouteImport } from './routes/turn-reports/$turnReportId'
import { Route as TrolleyRoutesNewRouteImport } from './routes/trolley-routes/new'
import { Route as TrolleyRoutesRouteIdRouteImport } from './routes/trolley-routes/$routeId'
import { Route as SettingsCategoryRouteImport } from './routes/settings/$category'
import { Route as ReportsReportTypeRouteImport } from './routes/reports/$reportType'
import { Route as NewsEntriesCreateRouteImport } from './routes/news-entries/create'
import { Route as NewsEntriesNewsEntryIdRouteImport } from './routes/news-entries/$newsEntryId'
import { Route as ExperiencesNewRouteImport } from './routes/experiences/new'
import { Route as DepotsNewRouteImport } from './routes/depots/new'
import { Route as DepotsDepotIdRouteImport } from './routes/depots/$depotId'
import { Route as CongregationsNewRouteImport } from './routes/congregations/new'
import { Route as CongregationsCongregationIdRouteImport } from './routes/congregations/$congregationId'
import { Route as CircuitsNewRouteImport } from './routes/circuits/new'
import { Route as CircuitsCircuitIdRouteImport } from './routes/circuits/$circuitId'
import { Route as AvailabilityCreateRouteImport } from './routes/availability/create'
import { Route as AvailabilityRecurrentApplicationIdRouteImport } from './routes/availability/$recurrentApplicationId'
import { Route as AbsencesCreateRouteImport } from './routes/absences.create'
import { Route as UsersPublisherIdIndexRouteImport } from './routes/users/$publisherId/index'
import { Route as ExperiencesExperienceIdIndexRouteImport } from './routes/experiences/$experienceId/index'
import { Route as DocumentsFolderIdIndexRouteImport } from './routes/documents/$folderId/index'
import { Route as WeekplanYearWeekRouteImport } from './routes/weekplan/$year.$week'
import { Route as UsersPublisherIdAuditRouteImport } from './routes/users/$publisherId/audit'
import { Route as ExperiencesExperienceIdEditTitleRouteImport } from './routes/experiences/$experienceId/edit-title'
import { Route as ExperiencesExperienceIdAddEventRouteImport } from './routes/experiences/$experienceId/add-event'
import { Route as DocumentsFolderIdNewFolderRouteImport } from './routes/documents/$folderId/newFolder'
import { Route as DocumentsFolderIdNewDocumentRouteImport } from './routes/documents/$folderId/newDocument'
import { Route as WeekplanYearWeekIndexRouteImport } from './routes/weekplan/$year.$week.index'
import { Route as WeekplanAssignmentShiftIdTurnIdRouteImport } from './routes/weekplan/assignment.$shiftId.$turnId'
import { Route as WeekplanYearWeekOverviewRouteImport } from './routes/weekplan/$year.$week.overview'
import { Route as WeekplanYearWeekDayChar123ShiftIdChar125RouteImport } from './routes/weekplan/$year.$week.$day.{-$shiftId}'
import { Route as ExperiencesExperienceIdEventsEventIdEditRouteImport } from './routes/experiences/$experienceId/events.$eventId.edit'
import { Route as ApplicationYearWeekDayChar123ShiftIdChar125RouteImport } from './routes/application/$year.$week.$day.{-$shiftId}'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperienceListRoute = ExperienceListRouteImport.update({
  id: '/experienceList',
  path: '/experienceList',
  getParentRoute: () => rootRouteImport,
} as any)
const EmergencyStatusRoute = EmergencyStatusRouteImport.update({
  id: '/emergency-status',
  path: '/emergency-status',
  getParentRoute: () => rootRouteImport,
} as any)
const EmergencyModeRoute = EmergencyModeRouteImport.update({
  id: '/emergency-mode',
  path: '/emergency-mode',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const UserProfileRouteRoute = UserProfileRouteRouteImport.update({
  id: '/user-profile',
  path: '/user-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationRouteRoute = ApplicationRouteRouteImport.update({
  id: '/application',
  path: '/application',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WeekplanIndexRoute = WeekplanIndexRouteImport.update({
  id: '/weekplan/',
  path: '/weekplan/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserProfileIndexRoute = UserProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UserProfileRouteRoute,
} as any)
const TurnReportsIndexRoute = TurnReportsIndexRouteImport.update({
  id: '/turn-reports/',
  path: '/turn-reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrolleyRoutesIndexRoute = TrolleyRoutesIndexRouteImport.update({
  id: '/trolley-routes/',
  path: '/trolley-routes/',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsEntriesIndexRoute = NewsEntriesIndexRouteImport.update({
  id: '/news-entries/',
  path: '/news-entries/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperiencesIndexRoute = ExperiencesIndexRouteImport.update({
  id: '/experiences/',
  path: '/experiences/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsIndexRoute = DocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => rootRouteImport,
} as any)
const DepotsIndexRoute = DepotsIndexRouteImport.update({
  id: '/depots/',
  path: '/depots/',
  getParentRoute: () => rootRouteImport,
} as any)
const CongregationsIndexRoute = CongregationsIndexRouteImport.update({
  id: '/congregations/',
  path: '/congregations/',
  getParentRoute: () => rootRouteImport,
} as any)
const CircuitsIndexRoute = CircuitsIndexRouteImport.update({
  id: '/circuits/',
  path: '/circuits/',
  getParentRoute: () => rootRouteImport,
} as any)
const AvailabilityIndexRoute = AvailabilityIndexRouteImport.update({
  id: '/availability/',
  path: '/availability/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationIndexRoute = ApplicationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ApplicationRouteRoute,
} as any)
const UsersCreateRoute = UsersCreateRouteImport.update({
  id: '/users/create',
  path: '/users/create',
  getParentRoute: () => rootRouteImport,
} as any)
const UserProfileSettingsRoute = UserProfileSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => UserProfileRouteRoute,
} as any)
const UserProfileRoutePreferencesRoute =
  UserProfileRoutePreferencesRouteImport.update({
    id: '/route-preferences',
    path: '/route-preferences',
    getParentRoute: () => UserProfileRouteRoute,
  } as any)
const UserProfileCalendarSubscriptionRoute =
  UserProfileCalendarSubscriptionRouteImport.update({
    id: '/calendar-subscription',
    path: '/calendar-subscription',
    getParentRoute: () => UserProfileRouteRoute,
  } as any)
const UserProfileAccountRoute = UserProfileAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => UserProfileRouteRoute,
} as any)
const TurnReportsTurnReportIdRoute = TurnReportsTurnReportIdRouteImport.update({
  id: '/turn-reports/$turnReportId',
  path: '/turn-reports/$turnReportId',
  getParentRoute: () => rootRouteImport,
} as any)
const TrolleyRoutesNewRoute = TrolleyRoutesNewRouteImport.update({
  id: '/trolley-routes/new',
  path: '/trolley-routes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TrolleyRoutesRouteIdRoute = TrolleyRoutesRouteIdRouteImport.update({
  id: '/trolley-routes/$routeId',
  path: '/trolley-routes/$routeId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsCategoryRoute = SettingsCategoryRouteImport.update({
  id: '/settings/$category',
  path: '/settings/$category',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsReportTypeRoute = ReportsReportTypeRouteImport.update({
  id: '/reports/$reportType',
  path: '/reports/$reportType',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsEntriesCreateRoute = NewsEntriesCreateRouteImport.update({
  id: '/news-entries/create',
  path: '/news-entries/create',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsEntriesNewsEntryIdRoute = NewsEntriesNewsEntryIdRouteImport.update({
  id: '/news-entries/$newsEntryId',
  path: '/news-entries/$newsEntryId',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperiencesNewRoute = ExperiencesNewRouteImport.update({
  id: '/experiences/new',
  path: '/experiences/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DepotsNewRoute = DepotsNewRouteImport.update({
  id: '/depots/new',
  path: '/depots/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DepotsDepotIdRoute = DepotsDepotIdRouteImport.update({
  id: '/depots/$depotId',
  path: '/depots/$depotId',
  getParentRoute: () => rootRouteImport,
} as any)
const CongregationsNewRoute = CongregationsNewRouteImport.update({
  id: '/congregations/new',
  path: '/congregations/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CongregationsCongregationIdRoute =
  CongregationsCongregationIdRouteImport.update({
    id: '/congregations/$congregationId',
    path: '/congregations/$congregationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CircuitsNewRoute = CircuitsNewRouteImport.update({
  id: '/circuits/new',
  path: '/circuits/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CircuitsCircuitIdRoute = CircuitsCircuitIdRouteImport.update({
  id: '/circuits/$circuitId',
  path: '/circuits/$circuitId',
  getParentRoute: () => rootRouteImport,
} as any)
const AvailabilityCreateRoute = AvailabilityCreateRouteImport.update({
  id: '/availability/create',
  path: '/availability/create',
  getParentRoute: () => rootRouteImport,
} as any)
const AvailabilityRecurrentApplicationIdRoute =
  AvailabilityRecurrentApplicationIdRouteImport.update({
    id: '/availability/$recurrentApplicationId',
    path: '/availability/$recurrentApplicationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AbsencesCreateRoute = AbsencesCreateRouteImport.update({
  id: '/absences/create',
  path: '/absences/create',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersPublisherIdIndexRoute = UsersPublisherIdIndexRouteImport.update({
  id: '/users/$publisherId/',
  path: '/users/$publisherId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperiencesExperienceIdIndexRoute =
  ExperiencesExperienceIdIndexRouteImport.update({
    id: '/experiences/$experienceId/',
    path: '/experiences/$experienceId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocumentsFolderIdIndexRoute = DocumentsFolderIdIndexRouteImport.update({
  id: '/documents/$folderId/',
  path: '/documents/$folderId/',
  getParentRoute: () => rootRouteImport,
} as any)
const WeekplanYearWeekRoute = WeekplanYearWeekRouteImport.update({
  id: '/weekplan/$year/$week',
  path: '/weekplan/$year/$week',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersPublisherIdAuditRoute = UsersPublisherIdAuditRouteImport.update({
  id: '/users/$publisherId/audit',
  path: '/users/$publisherId/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperiencesExperienceIdEditTitleRoute =
  ExperiencesExperienceIdEditTitleRouteImport.update({
    id: '/experiences/$experienceId/edit-title',
    path: '/experiences/$experienceId/edit-title',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExperiencesExperienceIdAddEventRoute =
  ExperiencesExperienceIdAddEventRouteImport.update({
    id: '/experiences/$experienceId/add-event',
    path: '/experiences/$experienceId/add-event',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocumentsFolderIdNewFolderRoute =
  DocumentsFolderIdNewFolderRouteImport.update({
    id: '/documents/$folderId/newFolder',
    path: '/documents/$folderId/newFolder',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocumentsFolderIdNewDocumentRoute =
  DocumentsFolderIdNewDocumentRouteImport.update({
    id: '/documents/$folderId/newDocument',
    path: '/documents/$folderId/newDocument',
    getParentRoute: () => rootRouteImport,
  } as any)
const WeekplanYearWeekIndexRoute = WeekplanYearWeekIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WeekplanYearWeekRoute,
} as any)
const WeekplanAssignmentShiftIdTurnIdRoute =
  WeekplanAssignmentShiftIdTurnIdRouteImport.update({
    id: '/weekplan/assignment/$shiftId/$turnId',
    path: '/weekplan/assignment/$shiftId/$turnId',
    getParentRoute: () => rootRouteImport,
  } as any)
const WeekplanYearWeekOverviewRoute =
  WeekplanYearWeekOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => WeekplanYearWeekRoute,
  } as any)
const WeekplanYearWeekDayChar123ShiftIdChar125Route =
  WeekplanYearWeekDayChar123ShiftIdChar125RouteImport.update({
    id: '/$day/{-$shiftId}',
    path: '/$day/{-$shiftId}',
    getParentRoute: () => WeekplanYearWeekRoute,
  } as any)
const ExperiencesExperienceIdEventsEventIdEditRoute =
  ExperiencesExperienceIdEventsEventIdEditRouteImport.update({
    id: '/experiences/$experienceId/events/$eventId/edit',
    path: '/experiences/$experienceId/events/$eventId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const ApplicationYearWeekDayChar123ShiftIdChar125Route =
  ApplicationYearWeekDayChar123ShiftIdChar125RouteImport.update({
    id: '/$year/$week/$day/{-$shiftId}',
    path: '/$year/$week/$day/{-$shiftId}',
    getParentRoute: () => ApplicationRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/application': typeof ApplicationRouteRouteWithChildren
  '/user-profile': typeof UserProfileRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/emergency-mode': typeof EmergencyModeRoute
  '/emergency-status': typeof EmergencyStatusRoute
  '/experienceList': typeof ExperienceListRoute
  '/home': typeof HomeRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/absences/create': typeof AbsencesCreateRoute
  '/availability/$recurrentApplicationId': typeof AvailabilityRecurrentApplicationIdRoute
  '/availability/create': typeof AvailabilityCreateRoute
  '/circuits/$circuitId': typeof CircuitsCircuitIdRoute
  '/circuits/new': typeof CircuitsNewRoute
  '/congregations/$congregationId': typeof CongregationsCongregationIdRoute
  '/congregations/new': typeof CongregationsNewRoute
  '/depots/$depotId': typeof DepotsDepotIdRoute
  '/depots/new': typeof DepotsNewRoute
  '/experiences/new': typeof ExperiencesNewRoute
  '/news-entries/$newsEntryId': typeof NewsEntriesNewsEntryIdRoute
  '/news-entries/create': typeof NewsEntriesCreateRoute
  '/reports/$reportType': typeof ReportsReportTypeRoute
  '/settings/$category': typeof SettingsCategoryRoute
  '/trolley-routes/$routeId': typeof TrolleyRoutesRouteIdRoute
  '/trolley-routes/new': typeof TrolleyRoutesNewRoute
  '/turn-reports/$turnReportId': typeof TurnReportsTurnReportIdRoute
  '/user-profile/account': typeof UserProfileAccountRoute
  '/user-profile/calendar-subscription': typeof UserProfileCalendarSubscriptionRoute
  '/user-profile/route-preferences': typeof UserProfileRoutePreferencesRoute
  '/user-profile/settings': typeof UserProfileSettingsRoute
  '/users/create': typeof UsersCreateRoute
  '/application/': typeof ApplicationIndexRoute
  '/availability/': typeof AvailabilityIndexRoute
  '/circuits/': typeof CircuitsIndexRoute
  '/congregations/': typeof CongregationsIndexRoute
  '/depots/': typeof DepotsIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/experiences/': typeof ExperiencesIndexRoute
  '/news-entries/': typeof NewsEntriesIndexRoute
  '/trolley-routes/': typeof TrolleyRoutesIndexRoute
  '/turn-reports/': typeof TurnReportsIndexRoute
  '/user-profile/': typeof UserProfileIndexRoute
  '/users/': typeof UsersIndexRoute
  '/weekplan/': typeof WeekplanIndexRoute
  '/documents/$folderId/newDocument': typeof DocumentsFolderIdNewDocumentRoute
  '/documents/$folderId/newFolder': typeof DocumentsFolderIdNewFolderRoute
  '/experiences/$experienceId/add-event': typeof ExperiencesExperienceIdAddEventRoute
  '/experiences/$experienceId/edit-title': typeof ExperiencesExperienceIdEditTitleRoute
  '/users/$publisherId/audit': typeof UsersPublisherIdAuditRoute
  '/weekplan/$year/$week': typeof WeekplanYearWeekRouteWithChildren
  '/documents/$folderId/': typeof DocumentsFolderIdIndexRoute
  '/experiences/$experienceId/': typeof ExperiencesExperienceIdIndexRoute
  '/users/$publisherId/': typeof UsersPublisherIdIndexRoute
  '/weekplan/$year/$week/overview': typeof WeekplanYearWeekOverviewRoute
  '/weekplan/assignment/$shiftId/$turnId': typeof WeekplanAssignmentShiftIdTurnIdRoute
  '/weekplan/$year/$week/': typeof WeekplanYearWeekIndexRoute
  '/application/$year/$week/$day/{-$shiftId}': typeof ApplicationYearWeekDayChar123ShiftIdChar125Route
  '/experiences/$experienceId/events/$eventId/edit': typeof ExperiencesExperienceIdEventsEventIdEditRoute
  '/weekplan/$year/$week/$day/{-$shiftId}': typeof WeekplanYearWeekDayChar123ShiftIdChar125Route
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/emergency-mode': typeof EmergencyModeRoute
  '/emergency-status': typeof EmergencyStatusRoute
  '/experienceList': typeof ExperienceListRoute
  '/home': typeof HomeRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/absences/create': typeof AbsencesCreateRoute
  '/availability/$recurrentApplicationId': typeof AvailabilityRecurrentApplicationIdRoute
  '/availability/create': typeof AvailabilityCreateRoute
  '/circuits/$circuitId': typeof CircuitsCircuitIdRoute
  '/circuits/new': typeof CircuitsNewRoute
  '/congregations/$congregationId': typeof CongregationsCongregationIdRoute
  '/congregations/new': typeof CongregationsNewRoute
  '/depots/$depotId': typeof DepotsDepotIdRoute
  '/depots/new': typeof DepotsNewRoute
  '/experiences/new': typeof ExperiencesNewRoute
  '/news-entries/$newsEntryId': typeof NewsEntriesNewsEntryIdRoute
  '/news-entries/create': typeof NewsEntriesCreateRoute
  '/reports/$reportType': typeof ReportsReportTypeRoute
  '/settings/$category': typeof SettingsCategoryRoute
  '/trolley-routes/$routeId': typeof TrolleyRoutesRouteIdRoute
  '/trolley-routes/new': typeof TrolleyRoutesNewRoute
  '/turn-reports/$turnReportId': typeof TurnReportsTurnReportIdRoute
  '/user-profile/account': typeof UserProfileAccountRoute
  '/user-profile/calendar-subscription': typeof UserProfileCalendarSubscriptionRoute
  '/user-profile/route-preferences': typeof UserProfileRoutePreferencesRoute
  '/user-profile/settings': typeof UserProfileSettingsRoute
  '/users/create': typeof UsersCreateRoute
  '/application': typeof ApplicationIndexRoute
  '/availability': typeof AvailabilityIndexRoute
  '/circuits': typeof CircuitsIndexRoute
  '/congregations': typeof CongregationsIndexRoute
  '/depots': typeof DepotsIndexRoute
  '/documents': typeof DocumentsIndexRoute
  '/experiences': typeof ExperiencesIndexRoute
  '/news-entries': typeof NewsEntriesIndexRoute
  '/trolley-routes': typeof TrolleyRoutesIndexRoute
  '/turn-reports': typeof TurnReportsIndexRoute
  '/user-profile': typeof UserProfileIndexRoute
  '/users': typeof UsersIndexRoute
  '/weekplan': typeof WeekplanIndexRoute
  '/documents/$folderId/newDocument': typeof DocumentsFolderIdNewDocumentRoute
  '/documents/$folderId/newFolder': typeof DocumentsFolderIdNewFolderRoute
  '/experiences/$experienceId/add-event': typeof ExperiencesExperienceIdAddEventRoute
  '/experiences/$experienceId/edit-title': typeof ExperiencesExperienceIdEditTitleRoute
  '/users/$publisherId/audit': typeof UsersPublisherIdAuditRoute
  '/documents/$folderId': typeof DocumentsFolderIdIndexRoute
  '/experiences/$experienceId': typeof ExperiencesExperienceIdIndexRoute
  '/users/$publisherId': typeof UsersPublisherIdIndexRoute
  '/weekplan/$year/$week/overview': typeof WeekplanYearWeekOverviewRoute
  '/weekplan/assignment/$shiftId/$turnId': typeof WeekplanAssignmentShiftIdTurnIdRoute
  '/weekplan/$year/$week': typeof WeekplanYearWeekIndexRoute
  '/application/$year/$week/$day/{-$shiftId}': typeof ApplicationYearWeekDayChar123ShiftIdChar125Route
  '/experiences/$experienceId/events/$eventId/edit': typeof ExperiencesExperienceIdEventsEventIdEditRoute
  '/weekplan/$year/$week/$day/{-$shiftId}': typeof WeekplanYearWeekDayChar123ShiftIdChar125Route
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/application': typeof ApplicationRouteRouteWithChildren
  '/user-profile': typeof UserProfileRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/emergency-mode': typeof EmergencyModeRoute
  '/emergency-status': typeof EmergencyStatusRoute
  '/experienceList': typeof ExperienceListRoute
  '/home': typeof HomeRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/absences/create': typeof AbsencesCreateRoute
  '/availability/$recurrentApplicationId': typeof AvailabilityRecurrentApplicationIdRoute
  '/availability/create': typeof AvailabilityCreateRoute
  '/circuits/$circuitId': typeof CircuitsCircuitIdRoute
  '/circuits/new': typeof CircuitsNewRoute
  '/congregations/$congregationId': typeof CongregationsCongregationIdRoute
  '/congregations/new': typeof CongregationsNewRoute
  '/depots/$depotId': typeof DepotsDepotIdRoute
  '/depots/new': typeof DepotsNewRoute
  '/experiences/new': typeof ExperiencesNewRoute
  '/news-entries/$newsEntryId': typeof NewsEntriesNewsEntryIdRoute
  '/news-entries/create': typeof NewsEntriesCreateRoute
  '/reports/$reportType': typeof ReportsReportTypeRoute
  '/settings/$category': typeof SettingsCategoryRoute
  '/trolley-routes/$routeId': typeof TrolleyRoutesRouteIdRoute
  '/trolley-routes/new': typeof TrolleyRoutesNewRoute
  '/turn-reports/$turnReportId': typeof TurnReportsTurnReportIdRoute
  '/user-profile/account': typeof UserProfileAccountRoute
  '/user-profile/calendar-subscription': typeof UserProfileCalendarSubscriptionRoute
  '/user-profile/route-preferences': typeof UserProfileRoutePreferencesRoute
  '/user-profile/settings': typeof UserProfileSettingsRoute
  '/users/create': typeof UsersCreateRoute
  '/application/': typeof ApplicationIndexRoute
  '/availability/': typeof AvailabilityIndexRoute
  '/circuits/': typeof CircuitsIndexRoute
  '/congregations/': typeof CongregationsIndexRoute
  '/depots/': typeof DepotsIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/experiences/': typeof ExperiencesIndexRoute
  '/news-entries/': typeof NewsEntriesIndexRoute
  '/trolley-routes/': typeof TrolleyRoutesIndexRoute
  '/turn-reports/': typeof TurnReportsIndexRoute
  '/user-profile/': typeof UserProfileIndexRoute
  '/users/': typeof UsersIndexRoute
  '/weekplan/': typeof WeekplanIndexRoute
  '/documents/$folderId/newDocument': typeof DocumentsFolderIdNewDocumentRoute
  '/documents/$folderId/newFolder': typeof DocumentsFolderIdNewFolderRoute
  '/experiences/$experienceId/add-event': typeof ExperiencesExperienceIdAddEventRoute
  '/experiences/$experienceId/edit-title': typeof ExperiencesExperienceIdEditTitleRoute
  '/users/$publisherId/audit': typeof UsersPublisherIdAuditRoute
  '/weekplan/$year/$week': typeof WeekplanYearWeekRouteWithChildren
  '/documents/$folderId/': typeof DocumentsFolderIdIndexRoute
  '/experiences/$experienceId/': typeof ExperiencesExperienceIdIndexRoute
  '/users/$publisherId/': typeof UsersPublisherIdIndexRoute
  '/weekplan/$year/$week/overview': typeof WeekplanYearWeekOverviewRoute
  '/weekplan/assignment/$shiftId/$turnId': typeof WeekplanAssignmentShiftIdTurnIdRoute
  '/weekplan/$year/$week/': typeof WeekplanYearWeekIndexRoute
  '/application/$year/$week/$day/{-$shiftId}': typeof ApplicationYearWeekDayChar123ShiftIdChar125Route
  '/experiences/$experienceId/events/$eventId/edit': typeof ExperiencesExperienceIdEventsEventIdEditRoute
  '/weekplan/$year/$week/$day/{-$shiftId}': typeof WeekplanYearWeekDayChar123ShiftIdChar125Route
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/application'
    | '/user-profile'
    | '/about'
    | '/contact'
    | '/emergency-mode'
    | '/emergency-status'
    | '/experienceList'
    | '/home'
    | '/privacy'
    | '/terms'
    | '/absences/create'
    | '/availability/$recurrentApplicationId'
    | '/availability/create'
    | '/circuits/$circuitId'
    | '/circuits/new'
    | '/congregations/$congregationId'
    | '/congregations/new'
    | '/depots/$depotId'
    | '/depots/new'
    | '/experiences/new'
    | '/news-entries/$newsEntryId'
    | '/news-entries/create'
    | '/reports/$reportType'
    | '/settings/$category'
    | '/trolley-routes/$routeId'
    | '/trolley-routes/new'
    | '/turn-reports/$turnReportId'
    | '/user-profile/account'
    | '/user-profile/calendar-subscription'
    | '/user-profile/route-preferences'
    | '/user-profile/settings'
    | '/users/create'
    | '/application/'
    | '/availability/'
    | '/circuits/'
    | '/congregations/'
    | '/depots/'
    | '/documents/'
    | '/experiences/'
    | '/news-entries/'
    | '/trolley-routes/'
    | '/turn-reports/'
    | '/user-profile/'
    | '/users/'
    | '/weekplan/'
    | '/documents/$folderId/newDocument'
    | '/documents/$folderId/newFolder'
    | '/experiences/$experienceId/add-event'
    | '/experiences/$experienceId/edit-title'
    | '/users/$publisherId/audit'
    | '/weekplan/$year/$week'
    | '/documents/$folderId/'
    | '/experiences/$experienceId/'
    | '/users/$publisherId/'
    | '/weekplan/$year/$week/overview'
    | '/weekplan/assignment/$shiftId/$turnId'
    | '/weekplan/$year/$week/'
    | '/application/$year/$week/$day/{-$shiftId}'
    | '/experiences/$experienceId/events/$eventId/edit'
    | '/weekplan/$year/$week/$day/{-$shiftId}'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/contact'
    | '/emergency-mode'
    | '/emergency-status'
    | '/experienceList'
    | '/home'
    | '/privacy'
    | '/terms'
    | '/absences/create'
    | '/availability/$recurrentApplicationId'
    | '/availability/create'
    | '/circuits/$circuitId'
    | '/circuits/new'
    | '/congregations/$congregationId'
    | '/congregations/new'
    | '/depots/$depotId'
    | '/depots/new'
    | '/experiences/new'
    | '/news-entries/$newsEntryId'
    | '/news-entries/create'
    | '/reports/$reportType'
    | '/settings/$category'
    | '/trolley-routes/$routeId'
    | '/trolley-routes/new'
    | '/turn-reports/$turnReportId'
    | '/user-profile/account'
    | '/user-profile/calendar-subscription'
    | '/user-profile/route-preferences'
    | '/user-profile/settings'
    | '/users/create'
    | '/application'
    | '/availability'
    | '/circuits'
    | '/congregations'
    | '/depots'
    | '/documents'
    | '/experiences'
    | '/news-entries'
    | '/trolley-routes'
    | '/turn-reports'
    | '/user-profile'
    | '/users'
    | '/weekplan'
    | '/documents/$folderId/newDocument'
    | '/documents/$folderId/newFolder'
    | '/experiences/$experienceId/add-event'
    | '/experiences/$experienceId/edit-title'
    | '/users/$publisherId/audit'
    | '/documents/$folderId'
    | '/experiences/$experienceId'
    | '/users/$publisherId'
    | '/weekplan/$year/$week/overview'
    | '/weekplan/assignment/$shiftId/$turnId'
    | '/weekplan/$year/$week'
    | '/application/$year/$week/$day/{-$shiftId}'
    | '/experiences/$experienceId/events/$eventId/edit'
    | '/weekplan/$year/$week/$day/{-$shiftId}'
  id:
    | '__root__'
    | '/'
    | '/application'
    | '/user-profile'
    | '/about'
    | '/contact'
    | '/emergency-mode'
    | '/emergency-status'
    | '/experienceList'
    | '/home'
    | '/privacy'
    | '/terms'
    | '/absences/create'
    | '/availability/$recurrentApplicationId'
    | '/availability/create'
    | '/circuits/$circuitId'
    | '/circuits/new'
    | '/congregations/$congregationId'
    | '/congregations/new'
    | '/depots/$depotId'
    | '/depots/new'
    | '/experiences/new'
    | '/news-entries/$newsEntryId'
    | '/news-entries/create'
    | '/reports/$reportType'
    | '/settings/$category'
    | '/trolley-routes/$routeId'
    | '/trolley-routes/new'
    | '/turn-reports/$turnReportId'
    | '/user-profile/account'
    | '/user-profile/calendar-subscription'
    | '/user-profile/route-preferences'
    | '/user-profile/settings'
    | '/users/create'
    | '/application/'
    | '/availability/'
    | '/circuits/'
    | '/congregations/'
    | '/depots/'
    | '/documents/'
    | '/experiences/'
    | '/news-entries/'
    | '/trolley-routes/'
    | '/turn-reports/'
    | '/user-profile/'
    | '/users/'
    | '/weekplan/'
    | '/documents/$folderId/newDocument'
    | '/documents/$folderId/newFolder'
    | '/experiences/$experienceId/add-event'
    | '/experiences/$experienceId/edit-title'
    | '/users/$publisherId/audit'
    | '/weekplan/$year/$week'
    | '/documents/$folderId/'
    | '/experiences/$experienceId/'
    | '/users/$publisherId/'
    | '/weekplan/$year/$week/overview'
    | '/weekplan/assignment/$shiftId/$turnId'
    | '/weekplan/$year/$week/'
    | '/application/$year/$week/$day/{-$shiftId}'
    | '/experiences/$experienceId/events/$eventId/edit'
    | '/weekplan/$year/$week/$day/{-$shiftId}'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ApplicationRouteRoute: typeof ApplicationRouteRouteWithChildren
  UserProfileRouteRoute: typeof UserProfileRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  ContactRoute: typeof ContactRoute
  EmergencyModeRoute: typeof EmergencyModeRoute
  EmergencyStatusRoute: typeof EmergencyStatusRoute
  ExperienceListRoute: typeof ExperienceListRoute
  HomeRoute: typeof HomeRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  AbsencesCreateRoute: typeof AbsencesCreateRoute
  AvailabilityRecurrentApplicationIdRoute: typeof AvailabilityRecurrentApplicationIdRoute
  AvailabilityCreateRoute: typeof AvailabilityCreateRoute
  CircuitsCircuitIdRoute: typeof CircuitsCircuitIdRoute
  CircuitsNewRoute: typeof CircuitsNewRoute
  CongregationsCongregationIdRoute: typeof CongregationsCongregationIdRoute
  CongregationsNewRoute: typeof CongregationsNewRoute
  DepotsDepotIdRoute: typeof DepotsDepotIdRoute
  DepotsNewRoute: typeof DepotsNewRoute
  ExperiencesNewRoute: typeof ExperiencesNewRoute
  NewsEntriesNewsEntryIdRoute: typeof NewsEntriesNewsEntryIdRoute
  NewsEntriesCreateRoute: typeof NewsEntriesCreateRoute
  ReportsReportTypeRoute: typeof ReportsReportTypeRoute
  SettingsCategoryRoute: typeof SettingsCategoryRoute
  TrolleyRoutesRouteIdRoute: typeof TrolleyRoutesRouteIdRoute
  TrolleyRoutesNewRoute: typeof TrolleyRoutesNewRoute
  TurnReportsTurnReportIdRoute: typeof TurnReportsTurnReportIdRoute
  UsersCreateRoute: typeof UsersCreateRoute
  AvailabilityIndexRoute: typeof AvailabilityIndexRoute
  CircuitsIndexRoute: typeof CircuitsIndexRoute
  CongregationsIndexRoute: typeof CongregationsIndexRoute
  DepotsIndexRoute: typeof DepotsIndexRoute
  DocumentsIndexRoute: typeof DocumentsIndexRoute
  ExperiencesIndexRoute: typeof ExperiencesIndexRoute
  NewsEntriesIndexRoute: typeof NewsEntriesIndexRoute
  TrolleyRoutesIndexRoute: typeof TrolleyRoutesIndexRoute
  TurnReportsIndexRoute: typeof TurnReportsIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  WeekplanIndexRoute: typeof WeekplanIndexRoute
  DocumentsFolderIdNewDocumentRoute: typeof DocumentsFolderIdNewDocumentRoute
  DocumentsFolderIdNewFolderRoute: typeof DocumentsFolderIdNewFolderRoute
  ExperiencesExperienceIdAddEventRoute: typeof ExperiencesExperienceIdAddEventRoute
  ExperiencesExperienceIdEditTitleRoute: typeof ExperiencesExperienceIdEditTitleRoute
  UsersPublisherIdAuditRoute: typeof UsersPublisherIdAuditRoute
  WeekplanYearWeekRoute: typeof WeekplanYearWeekRouteWithChildren
  DocumentsFolderIdIndexRoute: typeof DocumentsFolderIdIndexRoute
  ExperiencesExperienceIdIndexRoute: typeof ExperiencesExperienceIdIndexRoute
  UsersPublisherIdIndexRoute: typeof UsersPublisherIdIndexRoute
  WeekplanAssignmentShiftIdTurnIdRoute: typeof WeekplanAssignmentShiftIdTurnIdRoute
  ExperiencesExperienceIdEventsEventIdEditRoute: typeof ExperiencesExperienceIdEventsEventIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experienceList': {
      id: '/experienceList'
      path: '/experienceList'
      fullPath: '/experienceList'
      preLoaderRoute: typeof ExperienceListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emergency-status': {
      id: '/emergency-status'
      path: '/emergency-status'
      fullPath: '/emergency-status'
      preLoaderRoute: typeof EmergencyStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emergency-mode': {
      id: '/emergency-mode'
      path: '/emergency-mode'
      fullPath: '/emergency-mode'
      preLoaderRoute: typeof EmergencyModeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-profile': {
      id: '/user-profile'
      path: '/user-profile'
      fullPath: '/user-profile'
      preLoaderRoute: typeof UserProfileRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/application': {
      id: '/application'
      path: '/application'
      fullPath: '/application'
      preLoaderRoute: typeof ApplicationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weekplan/': {
      id: '/weekplan/'
      path: '/weekplan'
      fullPath: '/weekplan/'
      preLoaderRoute: typeof WeekplanIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-profile/': {
      id: '/user-profile/'
      path: '/'
      fullPath: '/user-profile/'
      preLoaderRoute: typeof UserProfileIndexRouteImport
      parentRoute: typeof UserProfileRouteRoute
    }
    '/turn-reports/': {
      id: '/turn-reports/'
      path: '/turn-reports'
      fullPath: '/turn-reports/'
      preLoaderRoute: typeof TurnReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trolley-routes/': {
      id: '/trolley-routes/'
      path: '/trolley-routes'
      fullPath: '/trolley-routes/'
      preLoaderRoute: typeof TrolleyRoutesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news-entries/': {
      id: '/news-entries/'
      path: '/news-entries'
      fullPath: '/news-entries/'
      preLoaderRoute: typeof NewsEntriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiences/': {
      id: '/experiences/'
      path: '/experiences'
      fullPath: '/experiences/'
      preLoaderRoute: typeof ExperiencesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/': {
      id: '/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof DocumentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/depots/': {
      id: '/depots/'
      path: '/depots'
      fullPath: '/depots/'
      preLoaderRoute: typeof DepotsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/congregations/': {
      id: '/congregations/'
      path: '/congregations'
      fullPath: '/congregations/'
      preLoaderRoute: typeof CongregationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/circuits/': {
      id: '/circuits/'
      path: '/circuits'
      fullPath: '/circuits/'
      preLoaderRoute: typeof CircuitsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability/': {
      id: '/availability/'
      path: '/availability'
      fullPath: '/availability/'
      preLoaderRoute: typeof AvailabilityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/application/': {
      id: '/application/'
      path: '/'
      fullPath: '/application/'
      preLoaderRoute: typeof ApplicationIndexRouteImport
      parentRoute: typeof ApplicationRouteRoute
    }
    '/users/create': {
      id: '/users/create'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof UsersCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-profile/settings': {
      id: '/user-profile/settings'
      path: '/settings'
      fullPath: '/user-profile/settings'
      preLoaderRoute: typeof UserProfileSettingsRouteImport
      parentRoute: typeof UserProfileRouteRoute
    }
    '/user-profile/route-preferences': {
      id: '/user-profile/route-preferences'
      path: '/route-preferences'
      fullPath: '/user-profile/route-preferences'
      preLoaderRoute: typeof UserProfileRoutePreferencesRouteImport
      parentRoute: typeof UserProfileRouteRoute
    }
    '/user-profile/calendar-subscription': {
      id: '/user-profile/calendar-subscription'
      path: '/calendar-subscription'
      fullPath: '/user-profile/calendar-subscription'
      preLoaderRoute: typeof UserProfileCalendarSubscriptionRouteImport
      parentRoute: typeof UserProfileRouteRoute
    }
    '/user-profile/account': {
      id: '/user-profile/account'
      path: '/account'
      fullPath: '/user-profile/account'
      preLoaderRoute: typeof UserProfileAccountRouteImport
      parentRoute: typeof UserProfileRouteRoute
    }
    '/turn-reports/$turnReportId': {
      id: '/turn-reports/$turnReportId'
      path: '/turn-reports/$turnReportId'
      fullPath: '/turn-reports/$turnReportId'
      preLoaderRoute: typeof TurnReportsTurnReportIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trolley-routes/new': {
      id: '/trolley-routes/new'
      path: '/trolley-routes/new'
      fullPath: '/trolley-routes/new'
      preLoaderRoute: typeof TrolleyRoutesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trolley-routes/$routeId': {
      id: '/trolley-routes/$routeId'
      path: '/trolley-routes/$routeId'
      fullPath: '/trolley-routes/$routeId'
      preLoaderRoute: typeof TrolleyRoutesRouteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/$category': {
      id: '/settings/$category'
      path: '/settings/$category'
      fullPath: '/settings/$category'
      preLoaderRoute: typeof SettingsCategoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/$reportType': {
      id: '/reports/$reportType'
      path: '/reports/$reportType'
      fullPath: '/reports/$reportType'
      preLoaderRoute: typeof ReportsReportTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news-entries/create': {
      id: '/news-entries/create'
      path: '/news-entries/create'
      fullPath: '/news-entries/create'
      preLoaderRoute: typeof NewsEntriesCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news-entries/$newsEntryId': {
      id: '/news-entries/$newsEntryId'
      path: '/news-entries/$newsEntryId'
      fullPath: '/news-entries/$newsEntryId'
      preLoaderRoute: typeof NewsEntriesNewsEntryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiences/new': {
      id: '/experiences/new'
      path: '/experiences/new'
      fullPath: '/experiences/new'
      preLoaderRoute: typeof ExperiencesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/depots/new': {
      id: '/depots/new'
      path: '/depots/new'
      fullPath: '/depots/new'
      preLoaderRoute: typeof DepotsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/depots/$depotId': {
      id: '/depots/$depotId'
      path: '/depots/$depotId'
      fullPath: '/depots/$depotId'
      preLoaderRoute: typeof DepotsDepotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/congregations/new': {
      id: '/congregations/new'
      path: '/congregations/new'
      fullPath: '/congregations/new'
      preLoaderRoute: typeof CongregationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/congregations/$congregationId': {
      id: '/congregations/$congregationId'
      path: '/congregations/$congregationId'
      fullPath: '/congregations/$congregationId'
      preLoaderRoute: typeof CongregationsCongregationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/circuits/new': {
      id: '/circuits/new'
      path: '/circuits/new'
      fullPath: '/circuits/new'
      preLoaderRoute: typeof CircuitsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/circuits/$circuitId': {
      id: '/circuits/$circuitId'
      path: '/circuits/$circuitId'
      fullPath: '/circuits/$circuitId'
      preLoaderRoute: typeof CircuitsCircuitIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability/create': {
      id: '/availability/create'
      path: '/availability/create'
      fullPath: '/availability/create'
      preLoaderRoute: typeof AvailabilityCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability/$recurrentApplicationId': {
      id: '/availability/$recurrentApplicationId'
      path: '/availability/$recurrentApplicationId'
      fullPath: '/availability/$recurrentApplicationId'
      preLoaderRoute: typeof AvailabilityRecurrentApplicationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/absences/create': {
      id: '/absences/create'
      path: '/absences/create'
      fullPath: '/absences/create'
      preLoaderRoute: typeof AbsencesCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$publisherId/': {
      id: '/users/$publisherId/'
      path: '/users/$publisherId'
      fullPath: '/users/$publisherId/'
      preLoaderRoute: typeof UsersPublisherIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiences/$experienceId/': {
      id: '/experiences/$experienceId/'
      path: '/experiences/$experienceId'
      fullPath: '/experiences/$experienceId/'
      preLoaderRoute: typeof ExperiencesExperienceIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/$folderId/': {
      id: '/documents/$folderId/'
      path: '/documents/$folderId'
      fullPath: '/documents/$folderId/'
      preLoaderRoute: typeof DocumentsFolderIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weekplan/$year/$week': {
      id: '/weekplan/$year/$week'
      path: '/weekplan/$year/$week'
      fullPath: '/weekplan/$year/$week'
      preLoaderRoute: typeof WeekplanYearWeekRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$publisherId/audit': {
      id: '/users/$publisherId/audit'
      path: '/users/$publisherId/audit'
      fullPath: '/users/$publisherId/audit'
      preLoaderRoute: typeof UsersPublisherIdAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiences/$experienceId/edit-title': {
      id: '/experiences/$experienceId/edit-title'
      path: '/experiences/$experienceId/edit-title'
      fullPath: '/experiences/$experienceId/edit-title'
      preLoaderRoute: typeof ExperiencesExperienceIdEditTitleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiences/$experienceId/add-event': {
      id: '/experiences/$experienceId/add-event'
      path: '/experiences/$experienceId/add-event'
      fullPath: '/experiences/$experienceId/add-event'
      preLoaderRoute: typeof ExperiencesExperienceIdAddEventRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/$folderId/newFolder': {
      id: '/documents/$folderId/newFolder'
      path: '/documents/$folderId/newFolder'
      fullPath: '/documents/$folderId/newFolder'
      preLoaderRoute: typeof DocumentsFolderIdNewFolderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/$folderId/newDocument': {
      id: '/documents/$folderId/newDocument'
      path: '/documents/$folderId/newDocument'
      fullPath: '/documents/$folderId/newDocument'
      preLoaderRoute: typeof DocumentsFolderIdNewDocumentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weekplan/$year/$week/': {
      id: '/weekplan/$year/$week/'
      path: '/'
      fullPath: '/weekplan/$year/$week/'
      preLoaderRoute: typeof WeekplanYearWeekIndexRouteImport
      parentRoute: typeof WeekplanYearWeekRoute
    }
    '/weekplan/assignment/$shiftId/$turnId': {
      id: '/weekplan/assignment/$shiftId/$turnId'
      path: '/weekplan/assignment/$shiftId/$turnId'
      fullPath: '/weekplan/assignment/$shiftId/$turnId'
      preLoaderRoute: typeof WeekplanAssignmentShiftIdTurnIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weekplan/$year/$week/overview': {
      id: '/weekplan/$year/$week/overview'
      path: '/overview'
      fullPath: '/weekplan/$year/$week/overview'
      preLoaderRoute: typeof WeekplanYearWeekOverviewRouteImport
      parentRoute: typeof WeekplanYearWeekRoute
    }
    '/weekplan/$year/$week/$day/{-$shiftId}': {
      id: '/weekplan/$year/$week/$day/{-$shiftId}'
      path: '/$day/{-$shiftId}'
      fullPath: '/weekplan/$year/$week/$day/{-$shiftId}'
      preLoaderRoute: typeof WeekplanYearWeekDayChar123ShiftIdChar125RouteImport
      parentRoute: typeof WeekplanYearWeekRoute
    }
    '/experiences/$experienceId/events/$eventId/edit': {
      id: '/experiences/$experienceId/events/$eventId/edit'
      path: '/experiences/$experienceId/events/$eventId/edit'
      fullPath: '/experiences/$experienceId/events/$eventId/edit'
      preLoaderRoute: typeof ExperiencesExperienceIdEventsEventIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/application/$year/$week/$day/{-$shiftId}': {
      id: '/application/$year/$week/$day/{-$shiftId}'
      path: '/$year/$week/$day/{-$shiftId}'
      fullPath: '/application/$year/$week/$day/{-$shiftId}'
      preLoaderRoute: typeof ApplicationYearWeekDayChar123ShiftIdChar125RouteImport
      parentRoute: typeof ApplicationRouteRoute
    }
  }
}

interface ApplicationRouteRouteChildren {
  ApplicationIndexRoute: typeof ApplicationIndexRoute
  ApplicationYearWeekDayChar123ShiftIdChar125Route: typeof ApplicationYearWeekDayChar123ShiftIdChar125Route
}

const ApplicationRouteRouteChildren: ApplicationRouteRouteChildren = {
  ApplicationIndexRoute: ApplicationIndexRoute,
  ApplicationYearWeekDayChar123ShiftIdChar125Route:
    ApplicationYearWeekDayChar123ShiftIdChar125Route,
}

const ApplicationRouteRouteWithChildren =
  ApplicationRouteRoute._addFileChildren(ApplicationRouteRouteChildren)

interface UserProfileRouteRouteChildren {
  UserProfileAccountRoute: typeof UserProfileAccountRoute
  UserProfileCalendarSubscriptionRoute: typeof UserProfileCalendarSubscriptionRoute
  UserProfileRoutePreferencesRoute: typeof UserProfileRoutePreferencesRoute
  UserProfileSettingsRoute: typeof UserProfileSettingsRoute
  UserProfileIndexRoute: typeof UserProfileIndexRoute
}

const UserProfileRouteRouteChildren: UserProfileRouteRouteChildren = {
  UserProfileAccountRoute: UserProfileAccountRoute,
  UserProfileCalendarSubscriptionRoute: UserProfileCalendarSubscriptionRoute,
  UserProfileRoutePreferencesRoute: UserProfileRoutePreferencesRoute,
  UserProfileSettingsRoute: UserProfileSettingsRoute,
  UserProfileIndexRoute: UserProfileIndexRoute,
}

const UserProfileRouteRouteWithChildren =
  UserProfileRouteRoute._addFileChildren(UserProfileRouteRouteChildren)

interface WeekplanYearWeekRouteChildren {
  WeekplanYearWeekOverviewRoute: typeof WeekplanYearWeekOverviewRoute
  WeekplanYearWeekIndexRoute: typeof WeekplanYearWeekIndexRoute
  WeekplanYearWeekDayChar123ShiftIdChar125Route: typeof WeekplanYearWeekDayChar123ShiftIdChar125Route
}

const WeekplanYearWeekRouteChildren: WeekplanYearWeekRouteChildren = {
  WeekplanYearWeekOverviewRoute: WeekplanYearWeekOverviewRoute,
  WeekplanYearWeekIndexRoute: WeekplanYearWeekIndexRoute,
  WeekplanYearWeekDayChar123ShiftIdChar125Route:
    WeekplanYearWeekDayChar123ShiftIdChar125Route,
}

const WeekplanYearWeekRouteWithChildren =
  WeekplanYearWeekRoute._addFileChildren(WeekplanYearWeekRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApplicationRouteRoute: ApplicationRouteRouteWithChildren,
  UserProfileRouteRoute: UserProfileRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  ContactRoute: ContactRoute,
  EmergencyModeRoute: EmergencyModeRoute,
  EmergencyStatusRoute: EmergencyStatusRoute,
  ExperienceListRoute: ExperienceListRoute,
  HomeRoute: HomeRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  AbsencesCreateRoute: AbsencesCreateRoute,
  AvailabilityRecurrentApplicationIdRoute:
    AvailabilityRecurrentApplicationIdRoute,
  AvailabilityCreateRoute: AvailabilityCreateRoute,
  CircuitsCircuitIdRoute: CircuitsCircuitIdRoute,
  CircuitsNewRoute: CircuitsNewRoute,
  CongregationsCongregationIdRoute: CongregationsCongregationIdRoute,
  CongregationsNewRoute: CongregationsNewRoute,
  DepotsDepotIdRoute: DepotsDepotIdRoute,
  DepotsNewRoute: DepotsNewRoute,
  ExperiencesNewRoute: ExperiencesNewRoute,
  NewsEntriesNewsEntryIdRoute: NewsEntriesNewsEntryIdRoute,
  NewsEntriesCreateRoute: NewsEntriesCreateRoute,
  ReportsReportTypeRoute: ReportsReportTypeRoute,
  SettingsCategoryRoute: SettingsCategoryRoute,
  TrolleyRoutesRouteIdRoute: TrolleyRoutesRouteIdRoute,
  TrolleyRoutesNewRoute: TrolleyRoutesNewRoute,
  TurnReportsTurnReportIdRoute: TurnReportsTurnReportIdRoute,
  UsersCreateRoute: UsersCreateRoute,
  AvailabilityIndexRoute: AvailabilityIndexRoute,
  CircuitsIndexRoute: CircuitsIndexRoute,
  CongregationsIndexRoute: CongregationsIndexRoute,
  DepotsIndexRoute: DepotsIndexRoute,
  DocumentsIndexRoute: DocumentsIndexRoute,
  ExperiencesIndexRoute: ExperiencesIndexRoute,
  NewsEntriesIndexRoute: NewsEntriesIndexRoute,
  TrolleyRoutesIndexRoute: TrolleyRoutesIndexRoute,
  TurnReportsIndexRoute: TurnReportsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  WeekplanIndexRoute: WeekplanIndexRoute,
  DocumentsFolderIdNewDocumentRoute: DocumentsFolderIdNewDocumentRoute,
  DocumentsFolderIdNewFolderRoute: DocumentsFolderIdNewFolderRoute,
  ExperiencesExperienceIdAddEventRoute: ExperiencesExperienceIdAddEventRoute,
  ExperiencesExperienceIdEditTitleRoute: ExperiencesExperienceIdEditTitleRoute,
  UsersPublisherIdAuditRoute: UsersPublisherIdAuditRoute,
  WeekplanYearWeekRoute: WeekplanYearWeekRouteWithChildren,
  DocumentsFolderIdIndexRoute: DocumentsFolderIdIndexRoute,
  ExperiencesExperienceIdIndexRoute: ExperiencesExperienceIdIndexRoute,
  UsersPublisherIdIndexRoute: UsersPublisherIdIndexRoute,
  WeekplanAssignmentShiftIdTurnIdRoute: WeekplanAssignmentShiftIdTurnIdRoute,
  ExperiencesExperienceIdEventsEventIdEditRoute:
    ExperiencesExperienceIdEventsEventIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
